















import Vue, { PropType } from 'vue';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-date-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionDateItemStoreEdit from '@/store/modules/cvSectionDateItemEdit';
import { CvSectionDateItem } from '@/../gen';
import { DATE_SEPARATOR_IN_FORM } from '@/utils/constants';
import { i18n, i18nHints } from '@/plugins/i18n';
import { splitDate } from '@/utils/date';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    sectionItem: {
      type: Object as PropType<CvSectionDateItem>,
      required: true,
    },
  },
  methods: {
    async onSubmit({
      title,
      organization,
      website_url,
      description,
      start_date,
      end_date,
    }: FormDataInterface) {
      const { cv_section_date_id, id } = this.sectionItem;
      const [start_date_year, start_date_month, start_date_day] = splitDate(
        start_date,
        DATE_SEPARATOR_IN_FORM
      );
      const [end_date_year, end_date_month, end_date_day] = splitDate(
        end_date,
        DATE_SEPARATOR_IN_FORM
      );
      await this.$store.dispatch(
        CvSectionDateItemStoreEdit.UpdateCvSectionDateItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_date_id,
            id,
          },
          body: {
            title,
            organization,
            website_url,
            description,
            start_date_year: start_date_year || '',
            start_date_month: start_date_month || '',
            start_date_day: start_date_day || '',
            end_date_year: end_date_year || '',
            end_date_month: end_date_month || '',
            end_date_day: end_date_day || '',
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_section_date_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionDateItemStoreEdit.DeleteCvSectionDateItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_date_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
